import { ACCOUNT_TYPE, selectUserData, updateValue } from '../accountSlice'
import { useDispatch, useSelector } from 'react-redux'
import EditUserPopup from './EditUserPopup'

const type = ACCOUNT_TYPE.basic

const EditAccountUserPopup = () => {
  const { data } = useSelector(state => selectUserData(state, type))
  const dispatch = useDispatch()

  return (
    <EditUserPopup
      data={data || {}}
      callback={value => {
        dispatch(updateValue({ type, name: 'data', value }))
      }}
    />
  )
}

export default EditAccountUserPopup